import React from "react";
import { getValue } from "@utils/lodash";

function EntityMappingSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <defs>
        <clipPath id="clip-path-entity-mapping">
          <rect id="Rectangle_18172" data-name="Rectangle 18172" width="24" height="24" transform="translate(-10433 -6525)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Group_10477" data-name="Group 10477" transform="translate(-985 -860)">
        <g id="Group_10470" data-name="Group 10470">
          <circle id="Ellipse_3666" data-name="Ellipse 3666" cx="20" cy="20" r="20" transform="translate(985 860)" fill="#f3e8fc"/>
          <g id="Mask_Group_280" data-name="Mask Group 280" transform="translate(11426 7393)" clip-path="url(#clip-path-entity-mapping)">
            <path id="account_tree_FILL0_wght300_GRAD0_opsz24" d="M16.1-7.538v-3.086H12V-20.91H9.436v3.086H2.769v-7.714H9.436v3.086H16.1v-3.086h6.667v7.714H16.1V-20.91H13.538v8.743H16.1v-3.086h6.667v7.714H16.1ZM4.308-24v0ZM17.641-13.71v0Zm0-10.286v0Zm0,4.629h3.59V-24h-3.59v4.629Zm0,10.286h3.59V-13.71h-3.59v4.629ZM4.308-19.367H7.9V-24H4.308v4.629Z" transform="translate(-10433.77 -6496.461)" fill="#8339cb"/>
          </g>
        </g>
      </g>
    </svg>

  );
}

export default EntityMappingSvgComponent;
